/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * bdk/v2/services/library.proto
 * OpenAPI spec version: version not set
 */

/**
 * Possible Values:
 - True: All good
 - False: An error occurred
 - Unknown: Condition not applicable/relevant
 - Pending: Underlying process (upon which the condition depends) still ongoing
 */
export type V2BookConnectionConditionStatus =
  (typeof V2BookConnectionConditionStatus)[keyof typeof V2BookConnectionConditionStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const V2BookConnectionConditionStatus = {
  BOOK_CONNECTION_CONDITION_STATUS_TRUE:
    'BOOK_CONNECTION_CONDITION_STATUS_TRUE',
  BOOK_CONNECTION_CONDITION_STATUS_FALSE:
    'BOOK_CONNECTION_CONDITION_STATUS_FALSE',
  BOOK_CONNECTION_CONDITION_STATUS_UNKNOWN:
    'BOOK_CONNECTION_CONDITION_STATUS_UNKNOWN',
  BOOK_CONNECTION_CONDITION_STATUS_PENDING:
    'BOOK_CONNECTION_CONDITION_STATUS_PENDING',
} as const;
